import React from 'react';
import PackageLocations from '../PackageLocations/PackageLocations';
import PackagesDateRange from '../PackagesDateRange/PackagesDateRange';
import SearchButton from '../SearchButton/SearchButton';

const SearchRow = () => (
  <div className="row flex-align-end" data-testid="searchRow">
    <PackageLocations />
    <PackagesDateRange />
    <div className="col-md-1 col-xs-12 margin-b-sm-down pad-0-l-md-up">
      <SearchButton />
    </div>
  </div>
);

export default SearchRow;
